<div class="image-header"></div>

<!-- <div class="area-header"> -->
    <div class="area-titles">
        <div class="title">
            Parcele sua compra com o carnê digital!
        </div>
        <div class="subtitle">
            Agora, ficou ainda mais fácil pagar uma compra com a parceria do Banco SEMEAR
        </div>
    </div>
<!-- </div> -->

<div class="area-texts">
    <h1>O que é</h1>
    <p>O carnê digital é uma forma de parcelamento de compra sem precisar usar ou ter um cartão de crédito.</p>

    <p>Com ele, você tem mais comodidade e ainda escolhe o melhor prazo para pagamento. Simples como deve ser.</p>

    <h1>Quem somos</h1>
    <p>O SEMEAR é um banco mineiro com o propósito de facilitar e simplificar a vida financeira das pessoas, do varejo,
        do empreendedorismo e de quem mais buscar uma parceria incondicional.</p>

    <p>Com grande representatividade no território brasileiro, o Banco atende um público diversificado por meio de seus
        serviços múltiplos e inovadores. Sempre ressaltando seu verdadeiro propósito de inclusão e educação financeira.
    </p>
</div>

<div class="area-fixed-bottom d-flex justify-content-center flex-direction-column pt-0">
    <div class="row">
        <div class="container mb-4">
            <div class="area-text-politicas">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                        [(ngModel)]="acceptTerms">
                    <label class="form-check-label" for="flexCheckDefault">
                        Estou ciente e de acordo com as <span class="link-terms" (click)="doTerms()">Políticas
                            de
                            Privacidade do Banco Semear S.A.</span>,
                        especialmente quanto a ofertas de serviços e
                        compartilhamento dos meus dados.
                    </label>
                </div>
            </div>
        </div>
    </div>
    <button class="btn btn-primary" (click)="next()" [disabled]="!acceptTerms">Entrar</button>
</div>